import { Box, Card } from '@theme-ui/components'
import React from 'react'

export default function DefinitionPage() {
  return (
    <Card>
      <h2>Apa yang perlu dilaporkan?</h2>
      <p>Jika anda melihat kejadian yang mencurigakan seperti:</p>
      <p>
        <strong>
          <b>1.Tindakan Curang (tidak adil)</b>
        </strong>
      </p>
      <p>
        Adalah tindakan yang dilakukan oleh seseorang/sekelompok Insan WBS
        dengan maksud untuk menguntungkan diri sendiri atau orang lain, dengan
        memakai nama palsu atau martabat palsu, dengan tipu muslihat, ataupun
        rangkaian kebohongan, ataupun menggerakkan orang lain untuk memberikan
        keuntungan kepadanya dengan cara-cara yang tidak benar dan melawan
        hukum.
      </p>
      <p>Contoh dari tindakan curang:</p>
      <ul>
        <li>
          Menyetujui pemberian order kepada supplier yang memiliki ‘hubungan
          istimewa’.
        </li>
        <li>
          Membayar atau tidak membayar vendor yang memiliki ‘hubungan istimewa’,
          yang secara langsung-tidak langsung memberi keuntungan komersial atau
          bentuk manfaat kompetitif lainnya bagi pada vendor lain.
        </li>
        <li>
          Merekrut staf yang memiliki ‘hubungan istimewa’ dengannya, sementara
          ada kandidat yang memiliki kualifikasi yang lebih baik.
        </li>
      </ul>
      <p>
        <strong>
          <b>2. Korupsi</b>
        </strong>
      </p>
      <p>
        Tindakan <strong>Insan WBS</strong>, yang secara tidak wajar dan tidak
        legal memperkaya diri atau memperkaya orang yang memiliki “hubungan
        istimewa” dengannya, dengan menyalahgunakan jabatan dan kekuasaan yang
        dipercayakan kepadanya.
      </p>
      <p>Contoh dari tindakan korupsi:</p>
      <ul>
        <li>
          Menyalahgunakan kekuasaan untuk kepentingan pribadi atau kelompok.
        </li>
        <li>
          Menerima keuntungan (contohnya uang, hadiah, keramah-tamahan) yang
          bertentangan dengan tanggung jawab jabatan.
        </li>
        <li>
          Menggunakan anggaran, harta, jasa pelayanan dan informasi perusahaan
          dan anak perusahaan untuk aktivitas di luar kedinasan.
        </li>
        <li>
          Menerima keuntungan (dalam bentuk apapun) dari siapapun selain dari
          gaji dan tunjangan yang berhak mereka terima.
        </li>
      </ul>
      <p>
        <strong>
          <b>3. Pencurian</b>
        </strong>
      </p>
      <p>
        Kegiatan/tindakan mengambil suatu barang, yang seluruhnya atau sebagian
        kepunyaan orang lain/perusahaan, dengan maksud untuk dimiliki secara
        melawan hukum. (KUHP Pasal 362).
      </p>
      <p>Contoh dari tindakan pencurian:</p>
      <ul>
        <li>
          Mengambil hak milik orang lain tanpa persetujuan dari pemilik
          tersebut.
        </li>
        <li>
          Menggunakan identitas diri orang lain untuk mendapatkan barang dan
          pelayanan.
        </li>
        <li>
          Menjual benda-benda dan menyimpan hasil dari penjualan secara rahasia.
        </li>
        <li>
          Menyalahgunakan/mengambil tanpa alasan hak uang/barang/data/ dokumen
          milik perusahaan dan/atau nasabah di lingkungan kerja.
        </li>
      </ul>
      <p>
        <strong>
          <b>4. Pelanggaran kebijakan dan peraturan perusahaan</b>
        </strong>
      </p>
      <p>
        Kegiatan/tindakan yang dilakukan oleh <strong>Insan WBS</strong> baik
        disengaja maupun terencana yang bertentangan dengan kebijakan dan
        peraturan internal Perusahaan dan anak Perusahaan. Pelaku pelanggaran
        ini dapat diancam sanksi menurut ketentuan internal maupun eksternal
        yang berlaku.
      </p>
      <p>
        Contoh dari tindakan pelanggaran kebijakan dan peraturan perusahaan :
      </p>
      <ul>
        <li>
          Menjalankan tugas di luar prosedur dan instruksi yang telah
          ditetapkan.
        </li>
        <li>
          Membocorkan informasi perusahaan, seperti anggaran, penawaran dari
          pemasok, strategi bisnis, dan lain sebagainya kepada orang-orang yang
          tidak berhak.
        </li>
        <li>
          Membuat dan/atau menggunakan dan/atau memberikan dan/atau mengubah
          dan/atau menyalin dan/atau menggandakan data dan/atau keterangan yang
          tidak sesuai dengan sebenarnya sehingga merugikan perusahaan dan/atau
          nasabah dan/atau (calon) investor.
        </li>
        <li>
          Pemberian fasilitas kredit atau perpanjangan waktu pembayaran
          kewajiban kepada pelanggan atau vendor/supplier yang terindikasi
          melanggar ketentuan dan berpotensi merugikan Perusahaan dan Anak
          Perusahaan secara ekonomi.
        </li>
      </ul>
      <p>
        <strong>
          <b>5. Benturan Kepentingan</b>
        </strong>
      </p>
      <p>
        Situasi dan kondisi dimana <strong>Insan WBS</strong> atau pemegang
        saham utama karena kedudukan atau jabatan di Perusahaan dan Anak
        Perusahaan menyalahgunakan wewenang secara baik sengaja maupun tidak
        sengaja untuk kepentingan pribadinya sehingga menimbulkan pertentangan
        antara kepentingan pribadi dan/atau kelompok dan/atau keluarga dengan
        kepentingan ekonomi Perusahaan dan Anak Perusahaan.
      </p>
      <p>
        Kondisi tersebut dapat mempengaruhi kualitas keputusan atas tugas yang
        diamanatkan kepadanya, sehingga kinerja hasil keputusan tersebut dapat
        merugikan Perusahaan dan Anak Perusahaan.
      </p>
      <p>Contoh dari benturan kepentingan :</p>
      <ul>
        <li>
          Menerima hadiah dalam bentuk uang atau hiburan dari vendor atau
          supplier.
        </li>
        <li>
          Menerima bantuan finansial atau non-finansial dari vendor atau
          supplier.&nbsp;Dimana seseorang atau pasangannya memiliki kepentingan
          yang bertentangan dengan kegiatan bisnis di perusahaan.
        </li>
        <li>
          Pemberian keputusan penunjukan pihak tertentu sebagai penyedia
          barang/jasa, dimana <strong>Insan WBS</strong> tersebut mempunyai
          kepentingan ekonomi pada pihak yang ditunjuk tersebut.
        </li>
      </ul>
      <p>
        <strong>
          <b>6. Penyuapan</b>
        </strong>
      </p>
      <p>
        Suatu tindakan / kegiatan yang dilakukan secara sengaja dan sadar
        memberi dan menerima sesuatu atau janji, sedangkan ia mengetahui atau
        patut dapat menduga bahwa pemberian sesuatu atau janji itu dimaksudkan
        supaya ia berbuat sesuatu atau tidak berbuat sesuatu dalam tugasnya,
        yang berlawanan dengan kewenangan atau kewajibannya yang menyangkut
        kepentingan umum. (Pasal 3 UU No. 11 Tahun 1980 tentang Tindak Pidana
        Suap)
      </p>
      <p>
        Pemberian dalam arti luas meliputi pemberian uang, barang, rabat,
        komisi, pinjaman tanpa bunga, tiket perjalanan, fasilitas penginapan,
        perjalanan wisata, pengobatan cuma-cuma, dan fasilitas lainnya. (Pasal
        12B UU No. 20 Tahun 2001 tentang Perubahan atas Undang-Undang nomor 31
        tahun 1999 tentang Pemberantasan Tindak Pidana Korupsi)
        <br />
        Contoh dari penyuapan/gratifikasi :
      </p>
      <ul>
        <li>
          Menerima imbalan secara langsung maupun tidak langsung dalam bentuk
          apapun dari pihak manapun yang terkait dengan suatu transaksi bisnis
        </li>
        <li>
          Menerima keuntungan-keuntungan dalam bentuk apapun yang mempengaruhi
          penilaian atau keputusan bisnis yang akan diambil
        </li>
      </ul>
      <p>
        <strong>
          <b>7. Penggelapan</b>
        </strong>
      </p>
      <p>
        Tindakan/kegiatan yang dilakukan dengan sengaja dan secara sadar melawan
        hukum untuk memiliki barang sesuatu yang seluruhnya atau sebagian adalah
        kepunyaan orang lain/perusahaan, yang saat ini ada dalam kekuasaannya
        bukan karena kejahatan. (KUHP Pasal 372).
      </p>
      <p>Contoh dari penggelapan :</p>
      <ul>
        <li>
          Dalam kekuasaannya baik karena jabatannya maupun bukan karena
          jabatannya, dengan sengaja dan melawan hukum memiliki suatu benda yang
          seluruhnya atau sebagian adalah milik perusahaan
        </li>
        <li>
          Melakukan tindakan tidak jujur dengan menyembunyikan barang/harta
          perusahaan tanpa sepengetahuan perusahaan dengan tujuan untuk
          memiliki, menguasai, atau digunakan untuk tujuan lain
        </li>
      </ul>
      <p>
        <strong>
          <b>8. Penipuan</b>
        </strong>
      </p>
      <p>
        Kegiatan/tindakan yang dilakukan secara sengaja dan sadar dengan maksud
        untuk menguntungkan diri sendiri atau orang lain secara melawan hukum,
        dengan memakai nama palsu atau martabat palsu, dengan tipu muslihat,
        ataupun rangkaian kebohongan, menggerakan orang lain untuk menyerahkan
        barang sesuatu kepadanya, atau supaya memberi hutang maupun menghapuskan
        piutang. (KUHP Pasal 378).
      </p>
      <p>Contoh dari tindakan penipuan:</p>
      <ul>
        <li>
          Suatu tipu muslihat yang dipakai oleh salah satu pihak sehingga
          menyebabkan pihak lain menandatangani kontrak tersebut, padahal tanpa
          tipu muslihat tersebut pihak lain itu tidak akan menandatangani
          kontrak yang bersangkutan.
        </li>
        <li>
          Dengan sengaja memberikan produk yang dalam kondisi rusak yang
          mengakibatkan kerugian dalam bentuk finansial.
        </li>
        <li>
          Bekerja sendiri ataupun bekerjasama dengan pihak lain untuk menipu
          atasan atau Perusahaan dengan menggunakan tanda tangan palsu atau
          faktur palsu.
        </li>
      </ul>
      <p>
        <strong>
          <b>9. Pemerasan</b>
        </strong>
      </p>
      <p>
        Kegiatan/tindakan yang dilakukan dengan maksud untuk menguntungkan diri
        sendiri atau orang lain secara melawan hukum, memaksa seorang dengan
        kekerasan atau ancaman kekerasan untuk memberikan barang sesuatu, yang
        seluruhnya atau sebagian adalah kepunyaan orang itu atau orang lain,
        atau supaya membuat hutang maupun menghapuskan piutang. (KUHP Pasal
        368).
      </p>
      <p>Contoh dari tindakan pemerasan:</p>
      <ul>
        <li>
          Melakukan pungutan tidak sah dalam bentuk apapun juga dalam
          menjalankan tugasnya untuk kepentingan pribadi/golongan/pihak lain.
        </li>
        <li>
          Meminta sejumlah uang atau hadiah kepada calon supplier sebagai
          pengganti untuk sebuah pekerjaan.
        </li>
        <li>
          Meminta sejumlah uang atau hadiah kepada pelanggan sebagai pengganti
          untuk sebuah pelayanan istimewa/khusus.
        </li>
      </ul>
      <p>
        <strong>
          <b>(*) Insan WBS</b>
        </strong>
      </p>
      <p>
        Adalah anggota direksi, anggota dewan komisaris, anggota komite, pegawai
        tetap/tidak tetap/outsourcing dari <strong>WBS</strong> dan Anak
        Perusahaan.
      </p>
    </Card>
  )
}
